import { createResource } from '@frappe-ui/resources/resources.js'

const API = 'retiora.api.notifications'

function request(method, params = {}) {
  const resource = createResource({ url: `${API}.${method}`, auto: false })
  return resource.fetch(params)
}

export function getNotifications(limit = 20) {
  return request('get_notifications', { limit })
}

export function markNotificationRead(notificationId) {
  return request('mark_notification_read', { notification_id: notificationId })
}

export function markAllNotificationsRead() {
  return request('mark_all_notifications_read')
}

export function getNotificationPreferences() {
  return request('get_notification_preferences')
}

export function updateNotificationPreferences(payload) {
  return request('update_notification_preferences', payload)
}

export function registerPushSubscription(payload) {
  return request('register_push_subscription', payload)
}

export function unregisterPushSubscription(payload) {
  return request('unregister_push_subscription', payload)
}

export function getVapidPublicKey() {
  return request('get_vapid_public_key')
}

